import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    container: {
        background: '#fff'
    },
    main: {
        height: '100%',
        flex: 1,
        overflow: 'hidden',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    wrapper: {
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        justifyContent: 'center'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        maxWidth: 1440,
        minHeight: '100%',
        padding: '0 48px',
        '@media (max-width: 1024px)': {
            padding: '0 24px'
        }
    },
    additional: {
        position: 'relative',
        padding: '40px 30px',
        boxShadow: '0px 10px 40px 0px #BAB8B033',
        transition: 'width 0.3s ease-in-out',
        '&>div>svg': {
            transition: 'all 0.3s linear'
        }
    },
    hideButton: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        left: -33,
        top: 300,
        height: 96,
        width: 32,
        background: '#fff',
        borderRadius: '12px 0px 0px 12px',
        borderRight: '1px solid #ECECEC',
        boxShadow: '-6px 0px 20px 0px #BAB8B033',
        cursor: 'pointer'
    },
    additionalHidden: {
        width: 0,
        padding: 0,
        '&>div>svg': {
            transform: 'rotate(180deg)'
        }
    }
});
